import cisco from 'ciscospark'

export default class Connection {

    constructor() {
        this.bot = 'NDFhMWJiNTYtYzNlMC00MWVhLThhODktZTlmZGY3ZjUzYjZmMzk2ZTJkOTMtMGU3_PF84_4d2a8a02-993c-403f-91a0-9ef167680fa1';
        this.spark = cisco.init({
            credentials: {
                access_token: this.bot
            }
        })
    }

    authenticateAsBot() {
        this.spark.credentials.set( {
            supertoken: this.bot
        } );
        return this.spark;
    }

    authenticateAsUser( token ) {
        this.spark.credentials.set({
            supertoken: token
        });
        return this.spark
    }

}